export const translation = {
  navigateToPaymentMethods: 'Selecciona otra forma de pago',
  payWithCard: 'Pagar con tarjeta',
  cardNumber: 'Número de tarjeta',
  cardExpiry: 'Fecha de vencimiento (MM/AA)',
  cardExpiryPlaceholder: 'MM/AA',
  cardCVV: 'CVV',
  cardholderName: 'Nombre del titular de la tarjeta',
  cardholderNamePlaceholder: 'Nombre completo',
  digits: 'dígitos',
  previouslyUsed: 'Previamente usado:',
  forgetPaymentMethods: 'Eliminar métodos de pago',
  forgetSavedCard: 'Eliminar tarjeta Terminada en {{last4Digits}}',
  required: 'Requerido',
  invalid: 'Inválido',
  cardInvalid: 'El número de tarjeta no es válido',
  expiryInvalid: 'La fecha de caducidad no es válida',
  expiryMonthInvalid: 'El mes de vencimiento no es válido',
  expiryYearInvalid: 'El año de vencimiento no es válido',
  cardExpired: 'La tarjeta ha caducado',
  cardIncomplete: 'El número de la tarjeta está incompleto',
  expiryIncomplete: 'La fecha de caducidad está incompleta',
  cvvIncomplete: 'El número CVV está incompleto',
  cvvInvalid3: 'CVV debe tener 3 dígitos',
  cvvInvalid4: 'CVV debe tener 4 dígitos',
  cardRequired: 'Se requiere el número de tarjeta',
  expiryRequired: 'Se requiere el número de tarjeta',
  cvvRequired: 'Se requiere el número CVV',
  cardNameRequired: 'Se requiere el nombre en la tarjeta',
  forgetPayPal: 'Eliminar cuenta de PayPal',
  savePaymentMethod: 'Guardar método de pago',
  managePaymentMethods: 'Administre sus métodos de pago',
  savedPaymentMethodsEmpty:
    'Ingrese los detalles de su tarjeta a continuación para agregar un nuevo método de pago',
  newPaymentMethod: 'Agregar una nueva forma de pago',
  cardEndingWith: 'Tarjeta que termina en',
  otherWaysToPay: 'Otras formas de pago',
  pay: 'Pagar',
  addCard: 'Agregar tarjeta',
  // Payment methods dropdown
  editPaymentMethods: 'Editar métodos de pago guardados',
  confirmCardDeletion: 'Confirmar - Eliminar tarjeta',
  confirmPayPalDeletion: 'Confirmar - Eliminar PayPal',
  delete: 'Eliminar',
  cancel: 'Cancelar',
  // Direct Debit Form
  accountHolder: 'Titular de la Cuenta',
  address: 'Dirección',
  addressLine1: 'Dirección línea 1',
  addressLine2: 'Dirección línea 2',
  fullName: 'Nombre',
  email: 'E-mail',
  city: 'Ciudad',
  postalCode: 'Código Postal',
  setUpDirectDebit: 'Preparar Direct Debit',
  unsupportedCardType: 'Tipo de tarjeta no admitido',
  // Success scene
  checkSuccessTitle: '¡Tu pago se ha realizado con éxito!',
  // Error
  tokenizationError:
    'No se pudo procesar su pago. Intente con otro método de pago.',

  duplicatePaymentMethodError: 'Esta forma de pago ya está guardada.',
  // Payment Method Popup Overlay
  paymentMethodPopupOverlayClose: 'Cerrar',
  paymentMethodPopupOverlayDescription:
    'Tiene problemas para ver la página de pago de {{paymentMethodName}}? ¡Te ayudaremos a encontrarlo!',
  paymentMethodPopupOverlayBringBackThePaymentPage: 'Mostrar la página de pago',
};
